import { render, staticRenderFns } from "./EmitirCertificado.vue?vue&type=template&id=91640798&"
import script from "./EmitirCertificado.vue?vue&type=script&lang=ts&"
export * from "./EmitirCertificado.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports